var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d7f0053ce8850e50e1a04fcbc62694b663477dc4"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prebuilt-ui@pluot-communications"]={id:"d7f0053ce8850e50e1a04fcbc62694b663477dc4"};
      